import { activeOptions } from 'components/aggregatorManagement/utils'
import { Dropdown, FormLayout, TextInput } from 'components/common'
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { LAST_MILES, storeFormFields } from './utils'

interface StoreDetailsFormProps {
  register: UseFormRegister<any>
  errors: FieldErrors<any>
  setValue: UseFormSetValue<any>
  store?: any
  isOptional?: boolean
}

// Return Order Last Mile Options
const orderLastMileOptions = LAST_MILES.map((item) => ({
  label: item,
  value: item,
  disabled: item === 'Fareye',
}))

const {
  STORE_ID,
  STORE_IS_ACTIVE,
  STORE_NAME,
  STORE_INSTASHOP_IDENTIFIER,
  STORE_LAST_MILE,
  STORE_TALABAT_ID,
  STORE_OOS_THRESHOLD,
  STORE_INVOICE_PREFIX_CODE,
} = storeFormFields

const StoreDetailsForm = ({
  register,
  errors,
  store,
  setValue,
  isOptional = false,
}: StoreDetailsFormProps) => {
  return (
    <>
      <div className="mb-1 flex items-start justify-between gap-5">
        <h3 className="title">Store Details</h3>

        {/* Store Active/Inactive */}
        <div className="w-full max-w-32">
          <Dropdown
            defaultValue={store?.[STORE_IS_ACTIVE.key] ?? true}
            setValue={setValue}
            options={activeOptions}
            name={STORE_IS_ACTIVE.key}
            error={errors?.[STORE_IS_ACTIVE.key]?.message as string}
          />
        </div>
      </div>

      <FormLayout>
        <div className="grid gap-x-5 gap-y-3 md:grid-cols-2">
          {/* Store ID */}
          <TextInput
            required={!isOptional}
            disabled={isOptional}
            label={STORE_ID.label}
            register={register}
            name={STORE_ID.key}
            error={errors?.[STORE_ID.key]?.message as string}
          />

          {/* Store Name */}
          <TextInput
            required
            label={STORE_NAME.label}
            register={register}
            name={STORE_NAME.key}
            error={errors?.[STORE_NAME.key]?.message as string}
          />
        </div>
      </FormLayout>

      <h3 className="title">Other Details</h3>

      <FormLayout>
        <div className="grid gap-x-5 gap-y-3 md:grid-cols-2">
          {/* Invoice Prefix Code */}
          <TextInput
            required
            register={register}
            label={STORE_INVOICE_PREFIX_CODE.label}
            name={STORE_INVOICE_PREFIX_CODE.key}
            error={errors?.[STORE_INVOICE_PREFIX_CODE.key]?.message as string}
          />
          {/* Store OOS_THRESHOLD */}
          <TextInput
            required
            label={STORE_OOS_THRESHOLD.label}
            register={register}
            name={STORE_OOS_THRESHOLD.key}
            error={errors?.[STORE_OOS_THRESHOLD.key]?.message as string}
          />

          {/* Store IDENTIFIER */}
          <TextInput
            label={STORE_INSTASHOP_IDENTIFIER.label}
            register={register}
            name={STORE_INSTASHOP_IDENTIFIER.key}
            error={errors?.[STORE_INSTASHOP_IDENTIFIER.key]?.message as string}
          />

          {/* Order Last Mile */}
          <Dropdown
            defaultValue={
              store?.[STORE_LAST_MILE.key] ?? orderLastMileOptions[0]
            }
            label={STORE_LAST_MILE.label}
            setValue={setValue}
            options={orderLastMileOptions}
            name={STORE_LAST_MILE.key}
            error={errors?.[STORE_LAST_MILE.key]?.message as string}
          />

          {/* Store TALABAT ID */}
          <TextInput
            label={STORE_TALABAT_ID.label}
            register={register}
            name={STORE_TALABAT_ID.key}
            error={errors?.[STORE_TALABAT_ID.key]?.message as string}
          />
        </div>
      </FormLayout>
    </>
  )
}

export default StoreDetailsForm
